define.alias("shared/components/shared/social/basic-display-deprecation/modal", "media/components/shared/social/basic-display-deprecation/modal");